import dixie from './images/dixie.jpg';

export const data = [
  {
    dogName: 'dixie',
    dogImage: dixie,
    handlers: ['pete plays', 'mary marvs'],
    city: 'charleston',
    state: 'sc',
    phone: '3213457890',
  },
];
